import React, { useState, useEffect, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { Layout, Menu } from 'antd';
import axios from 'axios';
import {
  HomeOutlined,
  LogoutOutlined,
  SyncOutlined,
  KeyOutlined,
  PictureOutlined,
} from '@ant-design/icons';
import {
  logoutUserRequest,
  refreshTokenRequest,
  validateTokenRequest,
} from 'modules/authModule/requests/authRequest';
import useToken from 'modules/authModule/hooks/useToken';
import currentRouteHelper from 'modules/layoutModule/helpers/currentRouteHelper';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';

import {
  ContactSubModuleDefinition,
  ContentSettingsSubModuleDefinition,
  GtwSubModuleDefinition,
  KnowledgeSubModuleDefinition,
  ModulesDefinition,
  modulesList,
  NewsSubModuleDefinition,
  SettingsSubModuleDefinition,
} from 'enums/modulesDefinition';
import { UserModulesDto } from 'modules/userModule/userDtos';

import { getUserById } from 'modules/userModule/request/userRequest';
import { NewsMenuTab } from 'modules/layoutModule/components/MenuTabs/NewsMenuTab';
import { KnowledgeMenuTab } from 'modules/layoutModule/components/MenuTabs/KnowledgeMenuTab';
import { SettingsMenuTab } from 'modules/layoutModule/components/MenuTabs/SettingsMenuTab';
import { ContentMenuTab } from 'modules/layoutModule/components/MenuTabs/ContentMenuTab';
import { ContactMenuTab } from 'modules/layoutModule/components/MenuTabs/ContactMenuTab';
import { FertilizersMenuTab } from 'modules/layoutModule/components/MenuTabs/FertilizersMenuTab';
import { GtwMenuTab } from 'modules/layoutModule/components/MenuTabs/GtwMenuTab';
import { GardenMenuTab } from 'modules/layoutModule/components/MenuTabs/GardenMenuTab';

import Home from 'modules/homeModule/components/Home';
import NewsAdd from 'modules/newsModule/components/NewsAdd';
import Knowledge from 'modules/knowledgeModule/components/Knowledge';
import NewsCategoriesAdd from 'modules/newsModule/components/NewsCategoriesAdd';
import NewsCategoriesEdit from 'modules/newsModule/components/NewsCategoriesEdit';
import NewsCategories from 'modules/newsModule/components/NewsCategories';
import NewsEdit from 'modules/newsModule/components/NewsEdit';
import News from 'modules/newsModule/components/News';
import FieldNewsAdd from 'modules/fieldNewsModule/components/FieldNewsAdd';
import FieldNewsEdit from 'modules/fieldNewsModule/components/FieldNewsEdit';
import FieldNews from 'modules/fieldNewsModule/components/FieldNews';
import AllCategoriesAdd from 'modules/allCategoriesModule/components/AllCategoriesAdd';
import AllCategoriesEdit from 'modules/allCategoriesModule/components/AllCategoriesEdit';
import AllCategories from 'modules/allCategoriesModule/components/AllCategories';
import NawozyTVAdd from 'modules/nawozyTVModule/components/NawozyTVAdd';
import NawozyTVEdit from 'modules/nawozyTVModule/components/NawozyTVEdit';
import NawozyTV from 'modules/nawozyTVModule/components/NawozyTV';
import SectionsAdd from 'modules/sectionsModule/components/SectionsAdd';
import SectionsEdit from 'modules/sectionsModule/components/SectionsEdit';
import Sections from 'modules/sectionsModule/components/Sections';
import ExpertArticlesAdd from 'modules/expertsModule/components/ExpertArticlesAdd';
import ExpertArticlesEdit from 'modules/expertsModule/components/ExpertArticlesEdit';
import ExpertArticles from 'modules/expertsModule/components/ExpertArticles';
import AddUser from 'modules/userModule/components/AddUser';
import UserEdit from 'modules/userModule/components/UserEdit';
import Users from 'modules/userModule/components/Users';
import Login from 'modules/authModule/components/Login/Login';
import Representatives from 'modules/contactModule/components/Representatives';
import RepresentativesEdit from 'modules/contactModule/components/RepresentativesEdit';
import RepresentativesAdd from 'modules/contactModule/components/RepresentativesAdd';
import Distribution from 'modules/contactModule/components/Distribution';
import DistributionEdit from 'modules/contactModule/components/DistributionEdit';
import DistributionAdd from 'modules/contactModule/components/DistributionAdd';
import DataProtection from 'modules/contactModule/components/DataProtection';
import Rules from 'modules/contactModule/components/Rules';
import Privacy from 'modules/contactModule/components/Privacy';
import ServiceMap from 'modules/contactModule/components/ServiceMap';
import ChangePassword from 'modules/authModule/components/ChangePassword/ChangePassword';
import FertilizationAdd from 'modules/knowledgeModule/components/FertilizationAdd';
import Fertilization from 'modules/knowledgeModule/components/Fertilization';
import FertilizationEdit from 'modules/knowledgeModule/components/FertilizationEdit';
import FertilizationSchedule from 'modules/knowledgeModule/components/FertilizationSchedule';
import FertilizationScheduleEdit from 'modules/knowledgeModule/components/FertilizationScheduleEdit';
import Banners from 'modules/bannersModule/components/Banners';
import BannersEdit from 'modules/bannersModule/components/BannersEdit';
import FertilizationScheduleAdd from 'modules/knowledgeModule/components/FertilizationScheduleAdd';
import AskExperts from 'modules/expertsModule/components/AskExperts';
import AskExpertsEdit from 'modules/expertsModule/components/AskExpertsEdit';
import AskExpertsAdd from 'modules/expertsModule/components/AskExpertsAdd';
import FertilizersParametersAdd from 'modules/fertilizersModule/components/FertilizersParametersAdd';
import FertilizersAdd from 'modules/fertilizersModule/components/FertilizersAdd';
import Fertilizers from 'modules/fertilizersModule/components/Fertilizers';
import FertilizersEdit from 'modules/fertilizersModule/components/FertilizersEdit';
import FertilizersCategoriesAdd from 'modules/fertilizersModule/components/FertilizersCategoriesAdd';
import FertilizersCategories from 'modules/fertilizersModule/components/FertilizersCategories';
import FertilizersCategoriesEdit from 'modules/fertilizersModule/components/FertilizersCategoriesEdit';
import FertilizersPackEdit from 'modules/fertilizersModule/components/FertilizersPackEdit';
import FertilizersPackAdd from 'modules/fertilizersModule/components/FertilizersPackAdd';
import FertilizersPack from 'modules/fertilizersModule/components/FertilizersPack';
import FertilizersParameters from 'modules/fertilizersModule/components/FertilizersParameters';
import GtwArticlesAdd from 'modules/gtwModule/components/GtwArticlesAdd';
import FertilizersParametersEdit from 'modules/fertilizersModule/components/FertilizersParametersEdit';
import GtwCategoriesAdd from 'modules/gtwModule/components/GtwCategoriesAdd';
import GtwCategories from 'modules/gtwModule/components/GtwCategories';
import GtwCategoriesEdit from 'modules/gtwModule/components/GtwCategoriesEdit';
import GtwArticles from 'modules/gtwModule/components/GtwArticles';
import GtwArticlesEdit from 'modules/gtwModule/components/GtwArticlesEdit';
import GtwRequirementsAdd from 'modules/gtwModule/components/GtwRequirementsAdd';
import GtwRequirements from 'modules/gtwModule/components/GtwRequirements';
import GtwRequirementsEdit from 'modules/gtwModule/components/GtwRequirementsEdit';
import GtwFilesAdd from 'modules/gtwModule/components/GtwFilesAdd';
import GtwFiles from 'modules/gtwModule/components/GtwFiles';
import GtwFilesEdit from 'modules/gtwModule/components/GtwFilesEdit';
import { checkIfAvailable } from 'helpers/moduleUrls';
import GtwEditionAdd from 'modules/gtwModule/components/GtwEditionAdd';
import GtwEditions from 'modules/gtwModule/components/GtwEditions';
import GtwEditionsEdit from 'modules/gtwModule/components/GtwEditionsEdit';
import AgroLiderAdd from 'modules/agroLiderModule/components/AgroLiderAdd';
import AgroLider from 'modules/agroLiderModule/components/AgroLider';
import AgroLiderEdit from 'modules/agroLiderModule/components/AgroLiderEdit';
import FertilizersDictionary from 'modules/fertilizersModule/components/FertilizersDictionary';
import FertilizersDictionaryEdit from 'modules/fertilizersModule/components/FertilizersDictionaryEdit';

import GardenExpertArticlesAdd from 'modules/expertsModule/components/GardenExpertArticlesAdd';
import GardenExpertArticlesEdit from 'modules/expertsModule/components/GardenExpertArticlesEdit';
import GardenExpertArticles from 'modules/expertsModule/components/GardenExpertArticles';
import GardenFertilizersAdd from 'modules/fertilizersModule/components/GardenFertilizersAdd';
import GardenFertilizers from 'modules/fertilizersModule/components/GardenFertilizers';
import GardenFertilizersEdit from 'modules/fertilizersModule/components/GardenFertilizersEdit';
import GardenFertilizersDictionary from 'modules/fertilizersModule/components/GardenFertilizersDictionary';
import GardenFertilizersDictionaryEdit from 'modules/fertilizersModule/components/GardenFertilizersDictionaryEdit';

import moment from 'moment';
import 'moment-timezone';
import './AppLayout.scss';

const { Content, Footer, Sider } = Layout;

axios.interceptors.response.use(
  (response) => response,
  (err) => {
    return new Promise((resolve) => {
      const originalReq = err.config;
      if (
        err.response?.status === 401 &&
        err.config &&
        !err.config.__isRetryRequest
      ) {
        originalReq._retry = true;
        const res = refreshTokenRequest().then((res) => {
          if (res) {
            const { data } = res;
            localStorage.setItem('token', JSON.stringify(data));
            originalReq.headers['Authorization'] = `Bearer ${data.accessToken}`;
          }
          return axios(originalReq);
        });
        resolve(res);
      }
      return Promise.reject(err);
    });
  }
);

const AppLayout = (): JSX.Element => {
  const [collapsed, toggleCollapse] = useState(false);
  const { token, setToken } = useToken();
  const [openedSubMenu, setOpenedSubMenu] = useState<string[]>([]);
  const [selectedMenu, setSelectedMenu] = useState<string[]>([]);
  const [userId, setUserId] = useState<string>('');
  const [userModules, setUserModules] = useState<UserModulesDto[]>([]);

  useEffect(() => {
    if (userModules && userModules.length > 0) {
      if (
        !checkIfAvailable(window.location.pathname, userModules) &&
        window.location.pathname !== '/'
      ) {
        window.location.href = '/';
      }
    }
  }, [userModules.length]);

  const subMenuClick = (e: any): void => {
    if (openedSubMenu.includes(e.key)) {
      setOpenedSubMenu([]);
    } else {
      setOpenedSubMenu([e.key]);
    }
  };

  const onLogout = () => {
    logoutUserRequest().then(() => {
      localStorage.removeItem('token');
      location.reload();
    });
  };

  const renderModules = (el: any) => {
    switch (el.id) {
      case ModulesDefinition.usersSettings:
        return SettingsMenuTab(
          subMenuClick,
          setSelectedMenu,
          SettingsSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.contact:
        return ContactMenuTab(
          subMenuClick,
          setSelectedMenu,
          ContactSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.contentSettings:
        return ContentMenuTab(
          subMenuClick,
          setSelectedMenu,
          ContentSettingsSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.news:
        return NewsMenuTab(
          subMenuClick,
          setSelectedMenu,
          NewsSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.gtw:
        return GtwMenuTab(
          subMenuClick,
          setSelectedMenu,
          GtwSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.knowledge:
        return KnowledgeMenuTab(
          subMenuClick,
          setSelectedMenu,
          KnowledgeSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.banners:
        // @ts-ignore
        if (userModules.includes('banners')) {
          return (
            <Menu.Item
              key={MenuIndexes.BANNERS}
              icon={<PictureOutlined />}
              onClick={(e) => {
                setSelectedMenu([e.key]);
                setOpenedSubMenu([]);
              }}
            >
              <Link to="/banners">{el.title}</Link>
            </Menu.Item>
          );
        }
        return <></>;
      case ModulesDefinition.fertilizers:
        return FertilizersMenuTab(
          subMenuClick,
          setSelectedMenu,
          ContactSubModuleDefinition,
          el.title,
          userModules
        );
      case ModulesDefinition.garden:
        return GardenMenuTab(
          subMenuClick,
          setSelectedMenu,
          {},
          el.title,
          userModules
        );
      default:
        return null;
    }
  };

  const fetchModules = async () => {
    await getUserById(userId).then((data) => {
      const modules =
        data.modules &&
        JSON.parse(data.modules).map((el: string) => {
          const splitModules = el.split('_');
          return {
            name: splitModules[0],
            subMenuData: splitModules[1],
          };
        });

      const outputArray: any = [];
      modules.forEach((item: any) => {
        const existing = outputArray.filter((el: any) => {
          return el.name == item.name;
        });
        if (existing.length) {
          const existingIndex = outputArray.indexOf(existing[0]);
          outputArray[existingIndex].subMenuData = [
            ...outputArray[existingIndex].subMenuData,
            item.subMenuData,
          ];
        } else {
          if (typeof item.subMenuData == 'string') {
            item.subMenuData = [item.subMenuData];
          }
          outputArray.push(item);
        }
      });
      setUserModules(JSON.parse(data.modules));
    });
  };

  useEffect(() => {
    if (userId && token && !userModules) {
      fetchModules();
    }
  }, [userId, token, userModules]);

  useEffect(() => {
    if (userModules.length === 0 && userId) {
      validateTokenRequest().then((response) => {
        if (response) {
          if (response.data) {
            if (response.data.changePassword) {
              if (!window.location.pathname.includes('/change-password')) {
                window.location.href = `/change-password?user=${response.data.userId}`;
              }
              return;
            }
            fetchModules();
          } else {
            setToken('');
            localStorage.setItem('token', '');
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }
        }
      });
    }
  }, [userModules, userId]);

  useEffect(() => {
    setOpenedSubMenu([currentRouteHelper()?.sub]);
    setSelectedMenu([currentRouteHelper()?.key]);
    const token = localStorage.getItem('token');
    if (token) {
      setUserId(JSON.parse(token).userId);
    }
  }, []);

  const renderModulesOrLoading = () => {
    if (userModules.length === 0) {
      return (
        <div className="menu-loader">
          <SyncOutlined spin />
        </div>
      );
    }
    return modulesList.map((module) => renderModules(module));
  };

  const isMenuVisible = () => {
    if (
      window.location.href.includes('/change-password') ||
      window.location.pathname === '/login'
    ) {
      return false;
    }
    if (token && token !== '') {
      return true;
    }
    return true;
  };

  return (
    <Layout
      style={{
        minHeight: '100vh',
      }}
    >
      <Router>
        {!token && <Redirect to="/login" />}
        {token && token !== '' && (
          <Sider
            style={{
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
              left: 0,
              display: isMenuVisible() ? '' : 'none',
            }}
            collapsible
            collapsed={collapsed}
            onCollapse={toggleCollapse}
            width={300}
          >
            <div className="logo" />
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={selectedMenu}
              openKeys={openedSubMenu}
              inlineIndent={10}
            >
              <Menu.Item
                key={MenuIndexes.HOME}
                icon={<HomeOutlined />}
                onClick={(e) => {
                  setSelectedMenu([e.key]);
                  setOpenedSubMenu([]);
                }}
              >
                <Link to="/">Strona Główna</Link>
              </Menu.Item>
              <Menu.Item
                key={MenuIndexes.PASSWORD_CHANGE}
                icon={<KeyOutlined />}
                onClick={(e) => {
                  setSelectedMenu([e.key]);
                  setOpenedSubMenu([]);
                }}
              >
                <Link to="/password">Zmień hasło</Link>
              </Menu.Item>
              {renderModulesOrLoading()}
              <Menu.Item key="9" icon={<LogoutOutlined />} onClick={onLogout}>
                Wyloguj się
              </Menu.Item>
            </Menu>
          </Sider>
        )}
        <Layout
          className="site-layout"
          style={{
            marginLeft: !isMenuVisible() ? 0 : collapsed ? 80 : 300,
            transition: collapsed ? 'all 0.4s' : '',
          }}
        >
          <Content
            style={{
              margin: '0 16px',
            }}
          >
            <Switch>
              <Route path="/login">
                <Suspense fallback={<SyncOutlined spin />}>
                  <Login setToken={setToken} setUserId={setUserId} />
                </Suspense>
              </Route>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/news/add">
                <NewsAdd />
              </Route>
              <Route path="/change-password">
                <ChangePassword showInfo />
              </Route>
              <Route path="/knowledge">
                <Knowledge />
              </Route>
              <Route path="/password">
                <ChangePassword />
              </Route>
              <Route path="/news/categories/add">
                <NewsCategoriesAdd />
              </Route>
              <Route path="/fertilizers-parameters/add">
                <FertilizersParametersAdd />
              </Route>

              <Route path="/agro-lider/add">
                <AgroLiderAdd />
              </Route>
              <Route path="/agro-lider/:id">
                <AgroLiderEdit />
              </Route>
              <Route path="/agro-lider">
                <AgroLider />
              </Route>

              <Route path="/fertilizers-dictionary/:id">
                <FertilizersDictionaryEdit />
              </Route>
              <Route path="/fertilizers-dictionary">
                <FertilizersDictionary />
              </Route>

              <Route path="/gtw-categories/add">
                <GtwCategoriesAdd />
              </Route>
              <Route path="/gtw-categories/:id">
                <GtwCategoriesEdit />
              </Route>
              <Route path="/gtw-categories">
                <GtwCategories />
              </Route>
              <Route path="/fertilizers-parameters/:id">
                <FertilizersParametersEdit />
              </Route>
              <Route path="/fertilizers-parameters">
                <FertilizersParameters />
              </Route>
              <Route path="/fertilizers/categories/add">
                <FertilizersCategoriesAdd />
              </Route>
              <Route path="/fertilizers/categories/:id">
                <FertilizersCategoriesEdit />
              </Route>
              <Route path="/fertilizers/categories">
                <FertilizersCategories />
              </Route>
              <Route path="/fertilizers/pack/add">
                <FertilizersPackAdd />
              </Route>
              <Route path="/fertilizers/pack/:id">
                <FertilizersPackEdit />
              </Route>
              <Route path="/fertilizers/add">
                <FertilizersAdd />
              </Route>
              <Route path="/fertilizers/pack">
                <FertilizersPack />
              </Route>
              <Route path="/fertilizers/:id">
                <FertilizersEdit />
              </Route>
              <Route path="/fertilizers">
                <Fertilizers />
              </Route>
              <Route path="/garden/expert-articles/add">
                <GardenExpertArticlesAdd />
              </Route>
              <Route path="/garden/expert-articles/:id">
                <GardenExpertArticlesEdit />
              </Route>
              <Route path="/garden/expert-articles">
                <GardenExpertArticles />
              </Route>
              <Route path="/garden/fertilizers/add">
                <GardenFertilizersAdd />
              </Route>
              <Route path="/garden/fertilizers/:id">
                <GardenFertilizersEdit />
              </Route>
              <Route path="/garden/fertilizers">
                <GardenFertilizers />
              </Route>
              <Route path="/garden/fertilizers-dictionary/:id">
                <GardenFertilizersDictionaryEdit />
              </Route>
              <Route path="/garden/fertilizers-dictionary">
                <GardenFertilizersDictionary />
              </Route>
              <Route path="/news/categories/:id">
                <NewsCategoriesEdit />
              </Route>
              <Route path="/news/categories">
                <NewsCategories />
              </Route>
              <Route path="/news/:id">
                <NewsEdit />
              </Route>
              <Route path="/news">
                <News />
              </Route>
              <Route path="/banners/:id">
                <BannersEdit />
              </Route>
              <Route path="/banners">
                <Banners />
              </Route>
              <Route path="/fertilization/add">
                <FertilizationAdd />
              </Route>
              <Route path="/fertilization/:id">
                <FertilizationEdit />
              </Route>
              <Route path="/fertilization">
                <Fertilization />
              </Route>
              <Route path="/fertilization-schedule/add">
                <FertilizationScheduleAdd />
              </Route>
              <Route path="/fertilization-schedule/:id">
                <FertilizationScheduleEdit />
              </Route>
              <Route path="/fertilization-schedule">
                <FertilizationSchedule />
              </Route>
              <Route path="/representatives/add">
                <RepresentativesAdd />
              </Route>
              <Route path="/representatives/:id">
                <RepresentativesEdit />
              </Route>
              <Route path="/representatives">
                <Representatives />
              </Route>
              <Route path="/ask-expert/add">
                <AskExpertsAdd />
              </Route>
              <Route path="/ask-expert/:id">
                <AskExpertsEdit />
              </Route>
              <Route path="/ask-expert">
                <AskExperts />
              </Route>
              <Route path="/distribution/add">
                <DistributionAdd />
              </Route>
              <Route path="/distribution/:id">
                <DistributionEdit />
              </Route>
              <Route path="/distribution">
                <Distribution />
              </Route>
              <Route path="/field-news/add">
                <FieldNewsAdd />
              </Route>
              <Route path="/field-news/:id">
                <FieldNewsEdit />
              </Route>
              <Route path="/field-news">
                <FieldNews />
              </Route>
              <Route path="/all-categories/add">
                <AllCategoriesAdd />
              </Route>
              <Route path="/all-categories/:id">
                <AllCategoriesEdit />
              </Route>
              <Route path="/all-categories">
                <AllCategories />
              </Route>
              <Route path="/nawozy-tv/add">
                <NawozyTVAdd />
              </Route>
              <Route path="/nawozy-tv/:id">
                <NawozyTVEdit />
              </Route>
              <Route path="/nawozy-tv">
                <NawozyTV />
              </Route>
              <Route path="/sections/add">
                <SectionsAdd />
              </Route>
              <Route path="/sections/:id">
                <SectionsEdit />
              </Route>
              <Route path="/sections">
                <Sections />
              </Route>
              <Route path="/gtw-requirements/add">
                <GtwRequirementsAdd />
              </Route>
              <Route path="/gtw-requirements/:id">
                <GtwRequirementsEdit />
              </Route>
              <Route path="/gtw-requirements">
                <GtwRequirements />
              </Route>

              <Route path="/gtw-editions/add">
                <GtwEditionAdd />
              </Route>
              <Route path="/gtw-editions/:id">
                <GtwEditionsEdit />
              </Route>
              <Route path="/gtw-editions">
                <GtwEditions />
              </Route>

              <Route path="/gtw-files/add">
                <GtwFilesAdd />
              </Route>
              <Route path="/gtw-files/:id">
                <GtwFilesEdit />
              </Route>
              <Route path="/gtw-files">
                <GtwFiles />
              </Route>

              <Route path="/gtw-art/add">
                <GtwArticlesAdd />
              </Route>
              <Route path="/gtw-art/:id">
                <GtwArticlesEdit />
              </Route>

              <Route path="/gtw-art">
                <GtwArticles />
              </Route>
              <Route path="/expert-articles/add">
                <ExpertArticlesAdd />
              </Route>
              <Route path="/expert-articles/:id">
                <ExpertArticlesEdit />
              </Route>
              <Route path="/expert-articles">
                <ExpertArticles />
              </Route>
              <Route path="/data-protection">
                <DataProtection />
              </Route>
              <Route path="/privacy">
                <Privacy />
              </Route>
              <Route path="/rules">
                <Rules />
              </Route>
              <Route path="/service-map">
                <ServiceMap />
              </Route>
              <Route path="/users/add-user">
                <AddUser />
              </Route>
              <Route path="/users/:userId">
                <UserEdit />
              </Route>
              <Route path="/users">
                <Users />
              </Route>
            </Switch>
          </Content>
          <Footer
            style={{
              textAlign: 'center',
            }}
          >
            &copy; 2021 - {moment().year()} Vilsone
          </Footer>
        </Layout>
      </Router>
    </Layout>
  );
};

export default AppLayout;
